import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'

/**
 * @typedef {Object}ConfirmationPopup
 */
/**
 * The upload file params
 * @component
 *
 * @param {Object} props
 * @param {function} [props.confirm]
 * @param {boolean} props.open
 * @param {string} props.title
 * @param {string} props.description
 * @param {function} props.closePopup
 * @returns {JSX.Element}
 */

const ConfirmationPopup = ({
  confirm = () => undefined,
  title,
  description,
  open,
  closePopup = () => undefined,
}) => {
  const handleConfirmation = () => {
    confirm()
    closePopup()
  }
  return (
    <Dialog
      open={open}
      onClose={closePopup}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={closePopup}>
          No
        </Button>
        <Button
          variant="contained"
          sx={{ bgcolor: '#f60000bf', '&:hover': { bgcolor: '#e30404e0' } }}
          onClick={handleConfirmation}
        >
          Sí
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationPopup
